import Highlight from '../Highlight';
import Link from 'next/link';
import { trackEvent } from '@monofront/tracking';
import { HitProps, ICollection } from '@monofront/types';
import { useGlobalSearchContext } from '../../../../../../context/GlobalSearchContext';

type ListBrandsProps = HitProps<ICollection>;

const ListBrands: React.FC<ListBrandsProps> = ({ hit, sendEvent }) => {
  const { setIsGlobalSearchResultsPanelOpen } = useGlobalSearchContext();

  return (
    <>
      <Link
        key={hit.objectID}
        href={`/collections/${hit.handle}`}
        legacyBehavior
      >
        <a
          className="suggestion"
          data-testid={`ListBrands-go-to-brand-${hit.handle}`}
          onClick={() => {
            sendEvent('click', hit, 'Click product');

            setIsGlobalSearchResultsPanelOpen(false);

            trackEvent({
              type: 'LFSearchRecommendationClick',
              data: {
                recommendationType: 'brand',
                brandName: hit.title,
                brandSlug: `/collections/${hit.handle}`,
                isSearchEmpty: false,
              },
            });
          }}
        >
          <Highlight hit={hit} attribute="title" />
        </a>
      </Link>
      <style jsx>{`
        .suggestion {
          padding: var(--space-1);
          margin-bottom: var(--space-2);
          cursor: pointer;
          transition: 0.3s;
          border-radius: var(--rd-1);
          display: inline-block;
        }

        .suggestion:hover {
          background-color: var(--clr-primary-5);
        }
      `}</style>
    </>
  );
};

export default ListBrands;
